export default __webpack_public_path__ + "205354d3f20b2850bd3f5595a9db7944.otf";